let counter = 0

/** Short, sortable, collision-free within a session. */
export function uid(prefix = 'n'): string {
  counter = (counter + 1) % 0xffff
  return `${prefix}_${Date.now().toString(36)}${counter.toString(36).padStart(3, '0')}`
}
